import React from 'react';
import './BookIcon.scss';

interface Props {
	size: number;
	animated?: boolean;
}

export const BookIcon: React.FC<Props> = props => (
	<svg
		className={props.animated ? 'animated book-icon' : 'book-icon'}
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>bookAlt</title>
		<path
			className='page three'
			d='M22.57,14.72H14.32a.39.39,0,0,1-.39-.4.39.39,0,0,1,.39-.4h8.25a.39.39,0,0,1,.4.4A.4.4,0,0,1,22.57,14.72Z'
		/>
		<path
			className='page two'
			d='M22.57,13.72H14.32a.39.39,0,0,1-.39-.4.39.39,0,0,1,.39-.4h8.25a.39.39,0,0,1,.4.4A.4.4,0,0,1,22.57,13.72Z'
		/>
		<path
			className='page one'
			d='M22.57,12.72H14.32a.39.39,0,0,1-.39-.4.39.39,0,0,1,.39-.4h8.25a.39.39,0,0,1,.4.4A.4.4,0,0,1,22.57,12.72Z'
		/>
		<path d='M22.57,14.72H14.32a.39.39,0,0,1-.39-.4.39.39,0,0,1,.39-.4h8.25a.39.39,0,0,1,.4.4A.4.4,0,0,1,22.57,14.72Z' />
		<path d='M12,17a4.15,4.15,0,0,1-1-.07A4.11,4.11,0,0,1,9.91,16a.42.42,0,0,0-.23-.06H.9a.4.4,0,0,1,0-.8H9.68a1.22,1.22,0,0,1,.78.28,4,4,0,0,0,.86.76,10.74,10.74,0,0,0,1.39,0,5.23,5.23,0,0,0,.8-.72,1.19,1.19,0,0,1,.81-.32H23.1a.4.4,0,1,1,0,.8H14.32a.39.39,0,0,0-.26.09,4,4,0,0,1-1.1.9A4.15,4.15,0,0,1,12,17Z' />
	</svg>
);
